import { useArtworkStepperStore } from '../stores/ArtworkStepperStore';

import { UploadPhotoStep } from './UploadPhotoStep';
import { EditPhotoStep } from './EditPhotoStep';

type Props = {
  onClose: (confirmClose?: boolean) => void;
};

export const CreatePhotoArtworkStepper: React.FC<Props> = ({ onClose }) => {
  const { activeStep } = useArtworkStepperStore();

  return (
    <>
      {activeStep === 0 && <UploadPhotoStep onClose={onClose} />}
      {activeStep === 1 && <EditPhotoStep onClose={onClose} />}
    </>
  );
};
